export default {
    getAllPushNotifications: env => {
        return {
            url: `/${env}/pushNotifications`,
            method: 'GET'
        };
    },
    getPushNotificationDetails: (env, pushNotificationId) => {
        return {
            url: `/${env}/pushNotifications/:pushNotificationId`,
            method: 'GET',
            route_params: {
                pushNotificationId
            }
        };
    },
    updatePushNotificationDetails: (env, form, pushNotificationId) => {
        let params = {};
        Object.keys(form).map(field => {
            if (form[field]) params[field] = form[field];
        });
        return {
            url: `/${env}/pushNotifications/:pushNotificationId`,
            method: 'PATCH',
            route_params: {
                pushNotificationId
            },
            patch_params: params
        };
    },
    addPushNotification: (env, form) => {
        let params = {};
        Object.keys(form).map(field => {
            if (form[field]) params[field] = form[field];
        });
        return {
            url: `/${env}/pushNotifications/add`,
            method: 'POST',
            post_params: params
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/PushNotifications/api.js